import {Component, Input} from "@angular/core";

@Component({
  selector: 'app-inventory-table',
  templateUrl: './inventory-table.component.html',
  styleUrls: ['./inventory-table.component.scss'],
  standalone: false
})

export class InventoryTableComponent {
  @Input() inventory: any[] = [];
  sortBy: string = '';
  sortDirection: string = '';

  constructor() {
  }

  ionViewWillEnter() {
    this.sortBy = 'name';
    this.sortDirection = 'asc';
    this.sortInventory('name');
  }

  sortInventory(sortValue: string) {
    if (this.sortBy !== sortValue) {
      this.sortDirection = 'asc';
    } else {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    }
    let sortDirection = this.sortDirection === 'asc' ? -1 : 1;

    this.sortBy = sortValue;
    let sortParam = sortValue;

    this.inventory.sort((a, b) => {
      if (a[sortParam] > b[sortParam]) return sortDirection;
      if (b[sortParam] > a[sortParam]) return -sortDirection;
      return 0;
    });
  }
}
